export default "__VITE_ASSET__8a31256b__"